import { useMemo } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Dropdown } from "antd";
import { Languages as LanguagesIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLanguages } from "../../hooks/useLanguages";
import { useChangeLanguage } from "../../hooks/useChangeLanguage";

/** Nút chọn ngôn ngữ hiển thị trong sidebar (danh sách lấy từ API languages). */
const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation();
  const [{ data: languages }] = useLanguages();
  const changeLanguage = useChangeLanguage();

  const items = useMemo(
    () =>
      (languages || []).map((l) => ({
        key: l.language_code,
        label: l.name,
      })),
    [languages]
  );

  if (items.length === 0) return null;

  return (
    <Dropdown
      placement="topLeft"
      trigger={["click"]}
      menu={{
        items,
        selectable: true,
        selectedKeys: [i18n.language],
        onClick: ({ key }) => changeLanguage(key),
      }}
    >
      <Tooltip title={t("sidebar.language.title")}>
        <IconButton
          size="small"
          aria-label={t("sidebar.language.title")}
          sx={{ color: "#fff", minWidth: 36, minHeight: 36 }}
        >
          <LanguagesIcon size={18} />
        </IconButton>
      </Tooltip>
    </Dropdown>
  );
};

export default LanguageSwitcher;
